<template>
  <div class="col-12">
    <div class="row mt-4">
      <div class="col-8 px-5">
        <h3>{{ $store.state.finetune_license ? "FineTune Line Selection" : "BLUEPRINT Program" }}</h3>
      </div>
      <hr class="horizontal dark" />
      <div class="col-8 px-5 mt-2">
        <h6 class="px-1">{{ $t("List of created Lines") }}</h6>
        <label class="text-sm"> {{ $t("Sort by") }}: &nbsp;</label>
        <select
          id="choices-category"
          v-model="order_by_attribute"
          name="order-by-choices"
          :class="`bg-transparent border-0 text-sm`"
        >
          <option
            v-for="order_by_option in order_by_options"
            :key="order_by_option"
            :value="order_by_option"
            class="text-dark text-sm"
          >
            <span class="d-sm-inline d-none">
              {{ $t(order_by_option) }}
            </span>
          </option>
        </select>
      </div>
      <div class="col-4 px-5 text-end mt-2">
        <div
          class="input-group"
          style="width: 250px; float: right"
        >
          <span class="input-group-text text-body">
            <i
              class="fas fa-search"
              aria-hidden="true"
            ></i>
          </span>
          <input
            v-model="search_keyword"
            type="text"
            class="form-control"
            :placeholder="$t('Search line here') + '...'"
          />
        </div>
      </div>
    </div>
    <div v-if="line_list.length">
      <br />
      <line-card-blue-print-fine-tune
        v-for="line in SortedFilteredLineList"
        :key="line.id"
        :line-name="line.name"
        :line-id="String(line.id)"
        :date-time="dateToString(line.created_at)"
        @line-card-clicked="routeToLinePage($event)"
      />
    </div>
    <div v-else>
      <p>{{ $t("No Lines Created") }}.</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  dateToString,
  OrderByDateCreated,
  OrderByDateUpdated,
  OrderByLineUsedDate,
  OrderByName,
} from "@/views/composables.js";
import LineCardBluePrintFineTune from "@/views/applications/components/LineCardBluePrintFineTune.vue";

export default {
  name: "LineListBluePrint",
  components: {
    LineCardBluePrintFineTune,
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;
    return {
      line_list: [],
      order_by_attribute: "Line Last Used Date",
      order_by_options: ["Name", "Line Creation Date", "Line Updated Date", "Line Last Used Date"],
      search_keyword: "",
    };
  },
  computed: {
    FilteredLineList() {
      if (this.search_keyword === "") {
        return this.line_list;
      } else {
        const keyword = this.search_keyword.toLowerCase();
        return this.line_list.filter(line => line.name.toLowerCase().includes(keyword));
      }
    },
    SortedFilteredLineList() {
      const array = this.FilteredLineList;
      switch (this.order_by_attribute) {
        case "Line Last Used Date":
          return this.OrderByLineUsedDate(array);
        case "Name":
          return this.OrderByName(array);
        case "Line Updated Date":
          return this.OrderByDateUpdated(array);
        case "Line Creation Date":
          return this.OrderByDateCreated(array);
        default:
          return array;
      }
    },
  },
  watch: {
    "$store.state.user_data.language"() {
      this.$i18n.locale = this.$store.state.user_data.language;
    },
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    dateToString,
    OrderByDateCreated,
    OrderByDateUpdated,
    OrderByLineUsedDate,
    OrderByName,
    async getData() {
      await this.getLineList();

      if (this.line_list.length == 1) {
        await this.routeToLinePage(this.line_list[0].id);
      }
    },
    async routeToLinePage(line_id) {
      if (this.$store.state.finetune_license) {
        this.$router.push({
          name: "FineTuneLineDashboard",
          params: { lineId: line_id },
        });
      } else if (this.$store.state.blueprint_license) {
        this.$router.push({
          name: "LineVisits",
          params: { lineId: line_id },
        });
      } else if (!this.$store.state.blueprint_license) {
        this.$router.push("/");
      }
    },
    async getLineList() {
      try {
        let get_lines_api_url = this.$store.state.finetune_license ? "api/v1/finetune/line/" : "/api/v1/fp/line/";

        const response = await axios.get(get_lines_api_url);
        this.line_list = response.data;
        this.$store.state.isLoading = false;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<i18n>
  {
    "EN": {
        "List of created Lines": "List of created Lines",
        "No Lines Created": "No Lines Created",
        "Sort by": "Sort by",
        "Name": "Name",
        "Line Creation Date": "Line Creation Date",
        "Line Updated Date": "Line Updated Date",
        "Line Last Used Date": "Line Last Used Date",
        "Search line here": "Search line here"
    },
    "DE": {
        "List of created Lines": "Liste der erstellten Linien",
        "No Lines Created": "Keine Linien erstellt",
        "Sort by": "Sortieren nach",
        "Name": "Name",
        "Line Creation Date": "Linien Erstellungsdatum",
        "Line Updated Date": "Linien Aktualisierungsdatum",
        "Line Last Used Date": "Zeile Zuletzt verwendetes Datum",
        "Search line here": "Suche Linie"
    },
    "ES": {
        "List of created Lines": "Lista de líneas creadas",
        "No Lines Created": "No existe ninguna línea",
        "Sort by": "Ordenar por",
        "Name": "Nombre",
        "Line Creation Date": "Fecha de creación",
        "Line Updated Date": "Fecha de actualización",
        "Line Last Used Date": "Fecha de último uso",
        "Search line here": "Buscar línea"
    },
    "FR": {
        "List of created Lines": "Liste des lignes créées",
        "No Lines Created": "Aucune ligne créée",
        "Sort by": "Trier par",
        "Name": "Nom",
        "Line Creation Date": "Date de création",
        "Line Updated Date": "Date de mise à jour",
        "Line Last Used Date": "Date de la dernière utilisation",
        "Search line here": "Rechercher une ligne"
    },
    "IT": {
        "List of created Lines": "Elenco delle linee create",
        "No Lines Created": "Nessuna linea creata Per creare una linea, contattaci a",
        "Sort by": "Ordina per",
        "Name": "Nome",
        "Line Creation Date": "Data di creazione",
        "Line Updated Date": "Data di aggiornamento",
        "Line Last Used Date": "Linea Data ultimo utilizzo",
        "Search line here": "Cerca linea"
    },
    "PL": {
        "List of created Lines": "Lista utworzonych linii",
        "No Lines Created": "Nie utworzono żadnych linii Aby utworzyć linię, skontaktuj się z nami pod adresem",
        "Sort by": "Sortuj według",
        "Name": "Nazwa",
        "Line Creation Date": "Data utworzenia",
        "Line Updated Date": "Data aktualizacji",
        "Line Last Used Date": "Linia Data ostatniego użycia",
        "Search line here": "Szukaj linii"
    },
    "TR": {
        "List of created Lines": "Oluşturulan Hatların Listesi",
        "No Lines Created": "Hat oluşturulmadı Bir hat oluşturmak için bizimle iletişime geçin",
        "Sort by": "Göre sırala",
        "Name": "İsim",
        "Line Creation Date": "Hat Oluşturma Tarihi",
        "Line Updated Date": "Hat Güncelleme Tarihi",
        "Line Last Used Date": "Hat Son Kullanım Tarihi",
        "Search line here": "Hat ara"
    },
    "ZH": {
        "List of created Lines": "创建的线列表",
        "No Lines Created": "未创建线。要创建线，请联系我们",
        "Sort by": "排序方式",
        "Name": "名称",
        "Line Creation Date": "创建日期",
        "Line Updated Date": "更新日期",
        "Line Last Used Date": "行 最后使用日期",
        "Search line here": "搜索线"
    }
  }
</i18n>
